import { Box, Button, Container, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { RouterLink } from 'src/components/router-link';
import { Seo } from 'src/components/seo';
import { usePageView } from 'src/hooks/use-page-view';
import { paths } from 'src/paths';

const Page = () => {
  const mdUp = useMediaQuery((theme) => theme.breakpoints.down('md'));

  usePageView();

  return (
    <>
      <Seo title="Error: Server Error" />
      <Box
        component="main"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 6,
            }}
          >
            <Box
              alt="Internal server error"
              component="img"
              src="/assets/errors/error-500.png"
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: 168,
              }}
            />
          </Box>
          <Typography align="center" variant={mdUp ? 'h4' : 'h5'}>
            500: Lỗi xảy ra
          </Typography>
          <Typography align="center" color="text.secondary" sx={{ mt: 0.5 }}>
            Server đang gặp sự cố. Vui lòng liên hệ hotline: 0932 168 077
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6,
            }}
          >
            <Button component={RouterLink} to={paths.index}>
              Về trang chủ
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Page;
